<template>
  <div
    ref="taskList"
    class="calendar-task-list"
  >
    <div class="calendar-task-list-header">
      <span class="calendar-task-list-date">
        {{ `${date.cMonth} 月` }}
        <task-tags :tags="tags" />
      </span>
      <span
        class="ibass ibass-close"
        @click="close"
      />
    </div>
    <div class="calendar-task-list-day">{{ `${date.cDay}日` }}</div>
    <div
      v-if="tasks.length > 0"
      class="calendar-task-list-items"
    >
      <template v-for="task in innerTasks" >
        <div
          v-if="task.name"
          :key="task.id"
          :class="{
            'calendar-task-list-item__done':task.state === 1
          }"
          class="calendar-task-list-item"
        >
          <el-popover
            v-model="task.triggered"
            placement="right"
            trigger="hover"
          >
            <task-info
              :task="task"
              @close="task.triggered=false"
              @finishTask="finishTask"
            />
            <div
              slot="reference"
              class="calendar-task-list-item-trigger"
            >
              <span
                v-if="task.state === TASK_DETAIL.STATE_FINISHED"
                class="ibass ibass-done"
              />
              <span class="calendar-task-list-item-label">{{ task.name }}</span>
            </div>
          </el-popover>
        </div>
      </template>
    </div>
    <div
      v-else
      class="calendar-task-list-empty"
    >暂无事件</div>
  </div>
</template>
<script>
import TaskInfo from './taskInfo'
import { TASK_DETAIL } from '@/utils/constants'
import _ from 'lodash'
import TaskTags from '@/biz-components/task-tags/index.vue'
export default {
  name: 'CalendarTaskList',
  components: {
    TaskTags,
    TaskInfo
  },
  props: {
    tasks: {
      type: Array,
      default: function () {
        return []
      }
    },
    date: {
      type: Object
    }
  },
  data () {
    return {
      TASK_DETAIL
    }
  },
  computed: {
    innerTasks () {
      return _.orderBy(this.tasks, ['state'], ['asc'])
    },
    tags() {
      return this.tasks.reduce((tags, task) => {
        return tags | task.tags
      }, 0)
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    finishTask () {
      this.$refs.taskList.click()
    }
  }
}
</script>
<style lang="stylus">
.calendar-task-list
  padding 10px
  width 154px
  &-header
    display flex
    justify-content space-between
    line-height 1
    .ibass-close
      color #999
      font-size .75rem
      cursor pointer
  &-date
    color #999
    font-size 10px
    .task-tags
      transform: translateY(-1px)
  &-day
    margin-top 2px
    font-weight 500
  &-items
    margin-top 7px
    max-height 175px
    overflow auto
  &-item
    margin-top 5px
    padding 2px 5px
    background-color #FCF4DB
    color #ED6C00
    border-radius 2px
    font-size 10px
    cursor pointer
    &.calendar-task-list-item__done
      background-color #f3f3f3
      color #a9a9a9
      .ibass-done
        margin-right 3px
        vertical-align -2px
      .calendar-task-list-item-label
        text-decoration line-through
  &-empty
    margin-top 15px
    color #999
    font-size 10px
</style>
